export const customerList = [
  { firstName: "Christabel", lastName: "Anayo", phoneNumber: "09088338800" },
  { firstName: "Adamu Gadi", lastName: "Gadi", phoneNumber: "09088338800" },
  { firstName: "Bernard", lastName: "Kelechi", phoneNumber: "09088338800" },
  { firstName: "Ahmed", LastName: "Gadi", phoneNumber: "09088338800" },
  { firstName: "Busayo", lastName: "Krista", phoneNumber: "09088338800" },
];
